import type { IAccountDropdownMenu } from 'libs/design-system/src/types/Dropdown/dropdown_menu/dropdown-menu';
import { Avatar } from '../../../Avatar';
import styles from './account.module.scss';

export const Account = ({
  avatarType = "placeholder",
  userName,
  userShortName,
  role,
  mId,
  staffId,
  imgUrl
}: IAccountDropdownMenu) => {

  let avatar = <></>;

  if (avatarType === 'img') {
    avatar = <Avatar
      type="img"
      imgUrl={imgUrl || ""}
      name={userName}
      focusable={false}
    />
  } else if (avatarType === 'text') {
    avatar = <Avatar
      type="text"
      shortName={userShortName || ""}
      focusable={false}
    />
  } else {
    avatar = <Avatar
      focusable={false}
    />
  }

  return (
    <div className={styles['user-info-box']}>
      {avatar}
      <div className={styles['user-info-box__user-info']}>
        {userName && <div className={styles['user-info-box__user-info__name']}>{userName}</div>}
        {mId && <div className={styles['user-info-box__user-info__supporting-info']}>{mId}</div>}
        {mId !== staffId && <div className={styles['user-info-box__user-info__supporting-info']}>{staffId}</div>}
      </div>
    </div>
  )
};
